<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputEmail" });
import Icon from "../../../../elements/icon/Icon.svelte";
export let email;
export let subject = void 0;
export let css = "";
$: url = `mailto:${email}${subject === void 0 ? "" : `?subject=${subject}`}`;
</script>

{#if email !== undefined }
    <a href = { url } class = { `s8-email ${ css }` }>
        <slot>
            <Icon key = 'mail' css = '!w-4 mr-1'/>
            <span class = 's8-label'> { email}</span>
        </slot>
    </a>
{/if}

<style>
    a.s8-email {
    display: flex
}</style>